<template>
  <div class="pages">
    <img class="top_img" :src="Util.getImgUrl(images.top)" />
    <img class="logo_img2" :src="Util.getImgUrl(images.logo)" />
    <img class="left_img" :src="Util.getImgUrl(images.left)" />
    <img class="right_img" :src="Util.getImgUrl(images.right)" />
    <div class="content" v-html="content"></div>
    <img class="nav_icon_img" :src="Util.getImgUrl(images.nav_icon)" @click="nav_show = true" />
    <employNav :nav_show.sync="nav_show"></employNav>
  </div>
</template>
<script>
import employNav from '../../components/employNav.vue'

export default {
  components: {
    employNav,
  },
  data() {
    return {
      nav_show: false,
      content: '',
      images: [],
    }
  },
  mounted() {
    document.title = '中船航海人才招聘'
    this.loadData()
  },
  methods: {
    loadData() {
      let that = this
      that.$api.employIndex({}).then(res => {
        that.Util.wechatShare(res.data.share)
        that.content = res.data.content
        that.images = res.data.images
      })
    },
    onNavClick(obj) {
      let that = this
      that.nav_show = false
      if (obj) {
        setTimeout(() => {
          if (obj.url) {
            window.location.href = obj.url
          } else if (obj.name) {
            that.$router.push(obj)
          }
        }, 100)
      }
    }
  }
}
</script>
<style scoped src="./employ.css"></style>
<style scoped src="./company.css"></style>
      